export default __webpack_public_path__ + "static/media/luminous_sands_from_guyun.fa5cdfa5.png";